<template>
    <div class="dropdown language-dropdown" v-if="!lodash.has(regionData,'sectionsToHide.languageSelector')"
         :class="{'language-dropdown--mobile' : screen ==='mobile', 'language-dropdown--desktop': screen === 'desktop', 'mr-4': !noMargin}">
        <button class="btn px-0 language-dropdown-button"
                id="languageDropdown"
                data-toggle="dropdown"
                aria-haspopup="true">
            {{ localeName }}
            <icon-component height="1em" :icon="fa_chevron_down()"></icon-component>
        </button>
        <div class="dropdown-menu" :class="{'dropdown-menu-right': screen === 'mobile'}" aria-labelledby="languageDropdown">
            <template v-for="language in settings.languages">
                <div v-if="language.locale !== locale" class="dropdown-item" @click="changeLanguage(language)">
                    {{ language.localName }}
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import xtrackingMixin from "@/components/mixins/xtrackingMixin";
import {fa_chevron_down} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

const data = () => {
    return {
        lodash: _,
        store: $store,
    }
}

async function changeLanguage(language) {
    const locale = language.locale;

    const [err, response] = await to(
        api.locale.change(locale)
    )

    const translate = _.get(response, 'data.translate');
    if (err || !translate) {
        return toastr.error(this.translate.home.errorCommon);
    }

    this.store.commit('setTranslate', translate);
    this.store.commit('setLocale', locale);
    this.store.commit('setRegionData', _.get(response, 'data.regionData'));

    const key = `navbar_language_${_.toLower(language.name)}`;

    if (typeof wpwlOptions !== "undefined") {
        wpwlOptions.locale = locale;
    }

    this.captureTrackingEvent(this.currentUser, 'language_selector', 'selected', key);
}

export default {
    components: {IconComponent},
    data,
    computed: {
        ...mapState(['settings', 'translate', 'locale', 'currentUser', 'regionData']),
        localeName() {
            if (this.screen === 'mobile') {
                return this.locale;
            }

            const lang = _.get(this, 'settings.languages', []).find(lang => lang.locale === this.locale);
            return _.get(lang, 'localName');
        }
    },
    props: {
        screen: {
            required: true
        },
        noMargin: {
            type: Boolean,
            default: false,
            required: false,
        }
    },
    methods: {
        fa_chevron_down,
        changeLanguage,
    },
    mixins: [
        xtrackingMixin
    ]
}
</script>
